// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BargainBinsCategoryModel } from "@awc/App/Services/BargainBin";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type BargainState = {
    bargains: any;
    isLoadingCategories: boolean;
    isProductLoading: boolean;
    selectedProductId: string;
    isLoadingBargains: boolean;
    productNotFound: boolean;
};

const initialxBargainState: BargainState = {
    bargains: null,
    isLoadingCategories: false,
    isProductLoading: false,
    selectedProductId: "",
    isLoadingBargains: false,
    productNotFound: false,
};

const xBargain = createTypedReducerWithImmer(initialxBargainState, {
    "xBargain/completed": (draft: Draft<BargainState>, action: { bargains: any }) => {
        draft.bargains = action.bargains;
        draft.isLoadingBargains = false;
    },
    "xBargain/LoadingBargains": (draft: Draft<BargainState>) => {
        draft.isLoadingBargains = true;
        draft.productNotFound = false;
    },
    "xBargain/SetIsLoadingCategories": (draft: Draft<BargainState>, action: { isLoadingCategories: boolean }) => {
        draft.isLoadingCategories = action.isLoadingCategories;
        draft.productNotFound = false;
    },
    "xBargain/isProductLoading": (draft: Draft<BargainState>) => {
        draft.isProductLoading = true;
        draft.selectedProductId = "";
        draft.productNotFound = false;
    },
    "xBargain/LoadingCategoriesCompleted": (
        draft: Draft<BargainState>,
        action: { categories: BargainBinsCategoryModel[] },
    ) => {
        draft.isLoadingCategories = false;
    },

    "xBargain/SetProductId": (draft: Draft<BargainState>, action: { id: string }) => {
        draft.isProductLoading = false;
        draft.selectedProductId = action.id;
    },
    "xBargain/ProductNotFound": (draft: Draft<BargainState>) => {
        draft.isLoadingBargains = false;
        draft.isProductLoading = false;
        draft.productNotFound = true;
    },
    "xBargain/ResetProductNotFound": (draft: Draft<BargainState>) => {
        draft.productNotFound = false;
    },
});

(reducers as any).xBargain = xBargain;

export type xBargainState = {
    xBargain: BargainState;
} & ApplicationState;

type xBargainReducers = {
    xBargain: typeof xBargain;
};

export type xBargainActions = Parameters<xBargainReducers[keyof xBargainReducers]>[1] | AnyAction;
